module.exports = __webpack_public_path__ + "static/covid-5-cddd7f0ba72e48dd2a9bd07f9dc6cdec.png";